webpackJsonp([15],{

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d936287c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "PrintTemplatesImportModal",
  props: ['companies', 'types'],
  data: function data() {
    return {
      err: '',
      loading: false,
      selectedCompany: null,
      templatesForImport: [],
      typeForImport: '',
      importHint: ''
    };
  },

  computed: {
    mappedCompanies: function mappedCompanies() {
      return this.companies.map(function (company) {
        return {
          text: company.name + ' (' + company.companyStatus + ')',
          value: company.id
        };
      });
    }
  },
  watch: {
    selectedCompany: function selectedCompany(val) {
      if (val) {
        this.fetchTemplateForCompany(val);
      }
    },
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    fetchTemplateForCompany: function fetchTemplateForCompany(id) {
      var _this2 = this;

      this.templatesForImport = [];
      this.loading = true;
      this.$http.post('printtemplate/fetchall', { companyId: id }).then(function (res) {
        if (res.body.status === 'Success') {
          _this2.templatesForImport = res.body.details;
          _this2.loading = false;
          return;
        }
        _this2.err = res.body.statusText;
        _this2.loading = false;
      }, function (err) {
        _this2.err = err.body.statusText || err.body.message;
        _this2.loading = false;
      });
    },
    submitTemplateImport: function submitTemplateImport() {
      var _this3 = this;

      this.importHint = '';
      var findPrintTemplate = this.templatesForImport.find(function (x) {
        return x.type === _this3.typeForImport && x.status === 'active';
      });
      if (findPrintTemplate) {
        this.$emit('submit', findPrintTemplate);
      } else {
        this.importHint = this.$lang.errors.noAvailableTemplate;
      }
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".pointerCursor[data-v-d936287c]{cursor:pointer}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/PrintTemplatesImportModal.vue"],"names":[],"mappings":"AACA,gCACE,cAAgB,CACjB","file":"PrintTemplatesImportModal.vue","sourcesContent":["\n.pointerCursor[data-v-d936287c] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("7cab7ed8", content, true, {});

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v("Import Print Template")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.keys(_vm.types),
      "label": _vm.selectedCompany ? _vm.$lang.actions.selectPrintTemplateType : 'Select Company first',
      "disabled": !_vm.selectedCompany || _vm.templatesForImport.length === 0,
      "hint": _vm.importHint,
      "persistent-hint": "",
      "loading": _vm.loading
    },
    model: {
      value: (_vm.typeForImport),
      callback: function($$v) {
        _vm.typeForImport = $$v
      },
      expression: "typeForImport"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": !_vm.typeForImport
    },
    on: {
      "click": function($event) {
        return _vm.submitTemplateImport()
      }
    }
  }, [_vm._v("\n      Submit\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.1417250595e405082cb8.js